import {TEST_TEXTURES} from "../pages/common/settings/module3d/detailTextures";
import {TEXTURE_PICTURE_SYSTEM_TYPE} from "../data/OrganizationCompositionPictureSystemType";

/** Negative ids — не пересекаются с реальными PictureDto.id с бэка. */
const MOCK_TEXTURE_ID_BASE = -1001;

/**
 * PictureDto-подобный каталог из встроенных ассетов (для fallback, пока by-textured пуст).
 */
export const MOCK_COMPOSITION_TEXTURES = TEST_TEXTURES.map((tex, index) => {
    const id = MOCK_TEXTURE_ID_BASE - index;
    return {
        id,
        name: tex.name,
        relativeUrl: tex.url,
        relativeUrlSmall: tex.url,
        priority: index,
        pictureSystemType: TEXTURE_PICTURE_SYSTEM_TYPE,
        mock: true,
    };
});

const MOCK_BY_ID = new Map(
    MOCK_COMPOSITION_TEXTURES.map((row) => [Number(row.id), row]),
);

export const isMockTextureId = (id) => MOCK_BY_ID.has(Number(id));

export const getMockTextureById = (id) => MOCK_BY_ID.get(Number(id)) ?? null;

export const getMockTexturesByIds = (ids) => {
    const out = [];
    const seen = new Set();
    for (const raw of Array.isArray(ids) ? ids : []) {
        const id = Number(raw);
        if (!Number.isFinite(id) || seen.has(id)) {
            continue;
        }
        const row = MOCK_BY_ID.get(id);
        if (row) {
            seen.add(id);
            out.push(row);
        }
    }
    return out;
};

/**
 * Если API вернул пустой/невалидный список — тестовый пул; иначе исходный список.
 * @param {unknown} list
 * @returns {{rows: object[], usedFallback: boolean}}
 */
export const withTextureCatalogFallback = (list) => {
    const rows = Array.isArray(list)
        ? list.filter((row) => row && row.id != null)
        : [];
    if (rows.length > 0) {
        return {rows, usedFallback: false};
    }
    return {rows: [...MOCK_COMPOSITION_TEXTURES], usedFallback: true};
};
